import { useState, useEffect } from "react";
import Axios from "axios";
import sha256 from "crypto-js/sha256";
import reactStringReplace from "react-string-replace";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

import "./notifications.css";
import SetTitle from "../../components/setTitle/SetTitle";
import HiddenBlock from "../../components/crudSql/hiddenBlock/HiddenBlock";
import { AlertData } from "../alerts/Alerts";
import LinearDeterminate from "../../components/mui/progress/LinearDeterminate";
import { mysqlDateHm } from "../../components/common/date";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";

// const depositWalletsA = {
//   BSC: { BUSD: "0x61d3193433e672df6ea91a77d80c95c9a32b4233" },
// };

export default function Notifications(props) {
  // console.log(props);

  SetTitle("Notifications @ DefiWatch.biz");
  const [isLoading, setIsLoading] = useState(true);

  const [alerts, setAlerts] = useState([]);
  const [alertsUnreadCnt, setAlertsUnreadCnt] = useState(0);
  const [paymentPeriod, setPaymentPeriod] = useState("Monthly");
  const [paymentPeriodMo, setPaymentPeriodMo] = useState(1);

  const moByPeriod = { Monthly: 1, Annually: 12 };
  useEffect(() => {
    // console.log("moByPeriod", paymentPeriod, moByPeriod[paymentPeriod]);
    setPaymentPeriodMo(moByPeriod[paymentPeriod]);
  }, [paymentPeriod]);

  // const getAlerts = (isChangeSidebarCnt = false) => {
  const getAlerts = (setNotificationCount = false) => {
    const apiUrl = "/notifications";
    Axios.get(
      process.env.REACT_APP_CRUD_SRV +
        apiUrl +
        "?auth=" +
        props.userAuthWallet +
        "&cs=" +
        sha256(apiUrl + props.userAuthWallet + process.env.REACT_APP_SECRET)
    ).then((res) => {
      // console.log("alerts", res.data.response.alerts);
      if (res.data?.status == 200) {
        // console.log(res.data.response.data?.constructor?.name == "Array");
        setAlerts(res.data.response.data);

        const _alertsUnreadCnt = res.data.response.data.filter(
          (item) => !item.readDt
        ).length;
        setAlertsUnreadCnt(_alertsUnreadCnt);
        // if (isChangeSidebarCnt) props.setNotificationCount(_alertsUnreadCnt);
        if (setNotificationCount) setNotificationCount(_alertsUnreadCnt);

        setIsLoading(false);
      }
    });
  };

  useEffect(() => {
    if (props.userAuthWallet != "") getAlerts();
  }, [props.userAuthWallet]);

  function handleClickAction(evt) {
    const action = evt.target.getAttribute("data-action");
    const rowJsonStr = evt.target.getAttribute("data-row");
    const row = JSON.parse(rowJsonStr);

    // if (props.smUserBalanceUsd < pricePerPeriod)
    //   toast.error(
    //     "Not enough balance. Please deposit minimum " +
    //       minDeposit +
    //       " BUSD to DefiWatch.biz wallet " +
    //       depositWalletsA.BSC.BUSD +
    //       " from your Metamask wallet " +
    //       props.userAuthWallet
    //   );
    // else {
    const apiUrl = "/notifications/" + action;
    // console.log(action, typeof row, {
    //   ...row,
    //   auth: props.userAuthWallet,
    // });
    Axios.post(process.env.REACT_APP_CRUD_SRV + apiUrl, {
      // tracked: row.trackedParameter,
      // threshold: row.threshold,
      // interval: row.minutesInterval,
      ...row,
      auth: props.userAuthWallet,
      cs: sha256(
        apiUrl +
          // row.trackedParameter +
          rowJsonStr +
          props.userAuthWallet +
          process.env.REACT_APP_SECRET
      ).toString(),
    }).then((r) => {
      if (r.data?.status == 200) {
        // console.log("Alert " + row.trackedParameter + " has been deleted.");
        if (action == "markAsRead")
          toast.info("Alert has been marked as read.");
        else toast.success("Alert has been deleted.");

        // Actions After Plan Upgrate

        getAlerts(props.setNotificationCount);
      } else {
        // toast.error("Alert deletion error. Please wait a while time and try again.");
        toast.error(
          "Alert " +
            (action == "markAsRead"
              ? " mark as read modification "
              : "deletion") +
            " error. " +
            process.env.REACT_APP_STR_TRY_AGAIN
        );
      }
    });
    // }
  }

  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const [status, setStatus] = useState("Unread");
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  // const [openPlans, setOpenPlans] = useState(false);
  // const handleClickOpenPlans = (evt) => {
  //   setOpenPlans(true);
  // };

  // const [openPaidPlans, setOpenPaidPlans] = useState(false);
  // const handleClickOpenPaidPlans = (evt) => {
  //   setPaidWallet(evt.target.getAttribute("data-wallet"));
  //   setOpenPaidPlans(true);
  // };
  // const [paidWallet, setPaidWallet] = useState(false);

  // const trackedParametersA = [
  //   { val: "tvl", ttl: "TVL has dropped (people exit the platform)" },
  //   {
  //     val: "balance",
  //     ttl: "Balance has dropped (someone withdrew tokens)",
  //   },
  //   {
  //     val: "balRwd",
  //     ttl: "Balance and Rewards do not change (non-working vault)",
  //   },
  //   {
  //     val: "total",
  //     ttl: "USD Total (Bal+Rwds), has dropped (tokens fall in dollar($) value)",
  //   },
  //   {
  //     val: "tokenUsd",
  //     ttl: "The dollar($) value of any token included in the LP has fallen",
  //   },
  //   {
  //     val: "balApr",
  //     ttl: "BalAPR below the specified (investment is not growing fast enough)",
  //     ttlShort: "Balance APR below",
  //   },
  //   {
  //     val: "totApr",
  //     ttl: "TotAPR below the specified (investment in $ value is not growing fast enough)",
  //   },
  // ];

  function showAlerts(_alerts) {
    let alertsR =
      _alerts?.constructor?.name == "Array" &&
      _alerts
        .filter(
          (item) =>
            status == "All" ||
            (status === "Unread" && !item.readDt) ||
            (status === "Read" && item.readDt)
        )
        // .filter((row) => row.wallet != props.userAuthWallet)
        .map((row) => {
          // const titlesA = trackedParametersA.filter(
          //   (obj) => obj.val == row.trackedParameter
          // )[0];
          const alertData = AlertData(row);

          return (
            <div
              key={row.idExt}
              className={
                "walletRow " +
                (row.readDt ? "notificationRowRead" : "notificationRowNotRead")
              }
            >
              <span className="notificationDat">{mysqlDateHm(row.dt)}</span>
              {/* <label>{row.text}</label> */}
              <label>
                {
                  // Match hashtags
                  reactStringReplace(row.text, /#(\w+)/g, (match, i) => (
                    <a
                      key={match + i}
                      // href={`https://twitter.com/hashtag/${match}`}
                      href={`/charts/${match}`}
                    >
                      #{match}
                    </a>
                  ))
                }
              </label>
              <label>{alertData.ttl}</label>
              <label
              // className={row.plan ? "walletBadgePaid" : "walletBadgeNotPaid"}
              >
                {/* {row.plan ? row.plan : "Not Active"} */}
                {+row.threshold}%
              </label>
              <label>on the basis of the last {alertData.interval}</label>
              <div className="notificationButtons">
                {row.readDt ? (
                  "Read " + mysqlDateHm(row.readDt)
                ) : (
                  <Button
                    // variant="contained"
                    variant="outlined"
                    className="extraSmall2Rows"
                    onClick={handleClickAction}
                    data-action="markAsRead"
                    data-row={JSON.stringify({ idExt: row.idExt })}
                    // color={row.dateEnd ? "success" : "primary"}
                  >
                    {/* {row.dateEnd ? "Prolong" : "Activate"} */}
                    Mark as Read
                  </Button>
                )}
                <Button
                  variant="outlined"
                  color="error"
                  className="extraSmall2Rows"
                  onClick={handleClickAction}
                  data-action="delete"
                  data-row={JSON.stringify({ idExt: row.idExt })}
                  // color={row.dateEnd ? "success" : "primary"}
                >
                  Delete
                </Button>
              </div>
            </div>
          );
        });

    return alertsR.length ? (
      alertsR
    ) : (
      <div className="nilNotifications">
        <p>You don't have any notifications.</p>
        <p>
          To start receiving notifications, add at least one{" "}
          <Link to="/account/alerts" className="link">
            alert
          </Link>
          .
        </p>
      </div>
    );
  }

  return (
    <div className="pageWallets pageAlerts">
      {/* <div className="paidWalletsHeader">
        <h3>Notifications</h3> */}
      {/* {props.userAuthWallet && (
          <Button
            variant="outlined"
            className="extraSmall addAdditionalWallet"
            onClick={handleClickOpen}
          >
            Add Alert
          </Button>
        )} */}
      {/* </div> */}
      <div className="topSubMenu">
        <h1>Notifications</h1>
        <div className="topSubMenuBlock">
          <FormControl
            variant="standard"
            className="vaultStatusMenu extraSmall"
            sx={{ m: 1, minWidth: 120 }}
          >
            {/* <InputLabel id="select-standard-label">Show</InputLabel> */}
            <Select
              labelId="select-standard-label"
              id="select-standard"
              value={status}
              onChange={handleStatusChange}
              label="Status"
              sx={{ height: 45 }}
            >
              <MenuItem value="All">
                {/* <em>All</em> */}
                All ({alerts.length})
              </MenuItem>
              {/* <MenuItem value={10}>Ten</MenuItem> */}
              <MenuItem value="Unread">Unread ({alertsUnreadCnt})</MenuItem>
              <MenuItem value="Read">
                Read ({alerts.length - alertsUnreadCnt})
              </MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>

      {isLoading ? (
        <LinearDeterminate />
      ) : (
        <>
          {/* <AddAlertDlg
        getAlerts={getAlerts}
        trackedParametersA={trackedParametersA}
        userAuthWallet={props.userAuthWallet}
        open={open}
        setOpen={setOpen}
      /> */}

          {/* <p className="paidWalletsP">
        DefiWatch alerts are interval based notifications when the investment
        meets your custom criteria.
      </p> */}

          {/* {props.userWallets[0]?.wallet} */}
          {showAlerts(alerts)}
        </>
      )}
    </div>
  );
}
